import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

// Layout
import Layout from "./components/layout/Layout";

// Pages
import HomePage from "./pages/HomePage";
import AIServicesPage from "./pages/AIServicesPage";
import AIConsultingPage from "./pages/AIConsultingPage";
import AgenticAIPage from "./pages/AgenticAIPage";
import AIProductsPage from "./pages/AIProductsPage";
import SmartChatbotPage from "./pages/SmartChatbotPage";
import ServicesPage from "./pages/ServicesPage";
import IndustriesPage from "./pages/IndustriesPage";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import CaseStudyDetailPage from "./pages/CaseStudyDetailPage";
import NetworkingBusinessPage from "./pages/NetworkingBusinessPage";
import ContactPage from "./pages/ContactPage";
import AboutCompanyPage from "./pages/AboutCompanyPage";
import LeadershipPage from "./pages/LeadershipPage";
import PartnersPage from "./pages/PartnersPage";
import LifeAtInfotechPage from "./pages/LifeAtInfotechPage";
import CareersPage from "./pages/CareersPage";
import BlogsPage from "./pages/BlogsPage";
import AdminBlog from "./pages/Admin/AdminBlog";
import AdminContact from "./pages/Admin/AdminContact";
import JobPageAdd from "./pages/Admin/JobPageAdd";
import JobPageEdit from "./pages/Admin/JobPageEdit";
import AdminJob from "./pages/Admin/AdminJob";
import JobPostResponse from "./pages/Admin/JobPostResponse";
import AdminUsers from "./pages/Admin/AdminUsers";

import BlogDetailPage from "./pages/BlogDetailPage";
import MobileAppDevelopmentPage from "./pages/MobileAppDevelopmentPage";
import ResourcesPage from "./pages/ResourcesPage";
import EngagementModelPage from "./pages/EngagementModelPage";
import AIStudioPage from "./pages/AIStudioPage";
import DedicatedCapabilityCentrePage from "./pages/DedicatedCapabilityCentrePage";
import StartupLabPage from "./pages/StartupLabPage";
import ProductEngineeringDetailPage from "./pages/ProductEngineeringDetailPage";
import WebAppDevelopmentPage from "./pages/WebAppDevelopmentPage";
import APIDevelopmentPage from "./pages/APIDevelopmentPage";
import IoTAppDevelopmentPage from "./pages/IoTAppDevelopmentPage";
import CustomIntegrationsPage from "./pages/CustomIntegrationsPage";
import ITSupportServicesPage from "./pages/ITSupportServicesPage";
import ProductManagementAdvisoryPage from "./pages/ProductManagementAdvisoryPage";
import ExperienceDesignPage from "./pages/ExperienceDesignPage";
import QualityAssuranceTestingPage from "./pages/QualityAssuranceTestingPage";

// Industry Pages
import EnergyIndustryPage from "./pages/EnergyIndustryPage";
import HealthcareIndustryPage from "./pages/HealthcareIndustryPage";
import FinanceIndustryPage from "./pages/FinanceIndustryPage";
import RetailIndustryPage from "./pages/RetailIndustryPage";
import TransportIndustryPage from "./pages/TransportIndustryPage";
import AIIndustryPage from "./pages/AIIndustryPage";
import EcommerceIndustryPage from "./pages/EcommerceIndustryPage";
import UtilityIndustryPage from "./pages/UtilityIndustryPage";
import LogisticsIndustryPage from "./pages/LogisticsIndustryPage";
import SalesMarketingIndustryPage from "./pages/SalesMarketingIndustryPage";
import SecurityIndustryPage from "./pages/SecurityIndustryPage";
import EdTechIndustryPage from "./pages/EdTechIndustryPage";
import AgriTechIndustryPage from "./pages/AgriTechIndustryPage";
import HRTechIndustryPage from "./pages/HRTechIndustryPage";
import LegalIndustryPage from "./pages/LegalIndustryPage";
import SportsIndustryPage from "./pages/SportsIndustryPage";
import LifestyleIndustryPage from "./pages/LifestyleIndustryPage";
import FitnessIndustryPage from "./pages/FitnessIndustryPage";
import CharityIndustryPage from "./pages/CharityIndustryPage";
import PrivacyNotice from "./pages/PrivacyNotice";
import Terms from "./pages/Terms";
import LoginPage from "./pages/LoginPage";

import BlogPageAdd from './pages/Admin/BlogPageAdd';
import BlogPageEdit from './pages/Admin/BlogPageEdit';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="top-right" richColors duration={3000} />
        <Layout>
          <Routes>
            {/* Home */}
            <Route path="/" element={<HomePage />} />

            {/* AI Services */}
            <Route path="/ai" element={<AIServicesPage />} />
            <Route path="/ai/ai-consulting" element={<AIConsultingPage />} />
            <Route path="/ai/agentic-ai" element={<AgenticAIPage />} />
            <Route path="/ai/ai-products" element={<AIProductsPage />} />
            <Route path="/ai/smart-ai-chatbot" element={<SmartChatbotPage />} />
            <Route path="/ai/:slug" element={<AIServicesPage />} />

            {/* What We Do (formerly Services) */}
            <Route path="/what-we-do" element={<ServicesPage />} />
            <Route
              path="/what-we-do/mobile-app-development"
              element={<MobileAppDevelopmentPage />}
            />
            <Route
              path="/what-we-do/engagement-model"
              element={<EngagementModelPage />}
            />
            <Route path="/what-we-do/ai-studio" element={<AIStudioPage />} />
            <Route
              path="/what-we-do/dedicated-capability-centre"
              element={<DedicatedCapabilityCentrePage />}
            />
            <Route
              path="/what-we-do/startup-lab"
              element={<StartupLabPage />}
            />
            <Route
              path="/what-we-do/product-engineering"
              element={<ProductEngineeringDetailPage />}
            />
            <Route
              path="/what-we-do/web-app-development"
              element={<WebAppDevelopmentPage />}
            />
            <Route
              path="/what-we-do/api-development"
              element={<APIDevelopmentPage />}
            />
            <Route
              path="/what-we-do/iot-app-development"
              element={<IoTAppDevelopmentPage />}
            />
            <Route
              path="/what-we-do/custom-integrations"
              element={<CustomIntegrationsPage />}
            />
            <Route
              path="/what-we-do/it-support-services"
              element={<ITSupportServicesPage />}
            />
            <Route
              path="/what-we-do/product-management-advisory"
              element={<ProductManagementAdvisoryPage />}
            />
            <Route
              path="/what-we-do/experience-design"
              element={<ExperienceDesignPage />}
            />
            <Route
              path="/what-we-do/quality-assurance-testing"
              element={<QualityAssuranceTestingPage />}
            />
            <Route path="/what-we-do/:slug" element={<ServicesPage />} />

            {/* Legacy routes for backward compatibility */}
            <Route path="/services" element={<ServicesPage />} />
            <Route
              path="/services/mobile-app-development"
              element={<MobileAppDevelopmentPage />}
            />
            <Route path="/services/:slug" element={<ServicesPage />} />
            <Route path="/product-engineering" element={<ServicesPage />} />
            <Route
              path="/product-engineering/:slug"
              element={<ServicesPage />}
            />

            {/* Industries */}
            <Route path="/industries" element={<IndustriesPage />} />
            <Route path="/industries/energy" element={<EnergyIndustryPage />} />
            <Route
              path="/industries/healthcare-medical"
              element={<HealthcareIndustryPage />}
            />
            <Route
              path="/industries/fintech-finance"
              element={<FinanceIndustryPage />}
            />
            <Route path="/industries/retail" element={<RetailIndustryPage />} />
            <Route
              path="/industries/transport"
              element={<TransportIndustryPage />}
            />
            <Route
              path="/industries/artificial-intelligence"
              element={<AIIndustryPage />}
            />
            <Route
              path="/industries/ecommerce-gig-commerce"
              element={<EcommerceIndustryPage />}
            />
            <Route
              path="/industries/utility"
              element={<UtilityIndustryPage />}
            />
            <Route
              path="/industries/logistics"
              element={<LogisticsIndustryPage />}
            />
            <Route
              path="/industries/sales-marketing"
              element={<SalesMarketingIndustryPage />}
            />
            <Route
              path="/industries/security"
              element={<SecurityIndustryPage />}
            />
            <Route
              path="/industries/edtech-education-training"
              element={<EdTechIndustryPage />}
            />
            <Route
              path="/industries/agritech"
              element={<AgriTechIndustryPage />}
            />
            <Route
              path="/industries/jobs-hr-tech"
              element={<HRTechIndustryPage />}
            />
            <Route path="/industries/legal" element={<LegalIndustryPage />} />
            <Route
              path="/industries/networking-business"
              element={<NetworkingBusinessPage />}
            />
            <Route path="/industries/sports" element={<SportsIndustryPage />} />
            <Route
              path="/industries/lifestyle"
              element={<LifestyleIndustryPage />}
            />
            <Route
              path="/industries/fitness"
              element={<FitnessIndustryPage />}
            />
            <Route
              path="/industries/charity-funding"
              element={<CharityIndustryPage />}
            />
            <Route path="/industries/:slug" element={<IndustriesPage />} />

            {/* Resources */}
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/resources/blogs" element={<BlogsPage />} />
            <Route path="/admin/blog-add" element={<BlogPageAdd />} />
            <Route path="/admin/blog-edit/:id" element={<BlogPageEdit />} />
            <Route path="/admin/blogs" element={<AdminBlog />} />
            <Route path="/admin/contacts" element={<AdminContact />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/jobs" element={<AdminJob />} />
            <Route path="/admin/job-add" element={<JobPageAdd />} />
            <Route path="/admin/job-edit/:id" element={<JobPageEdit />} />
            <Route
              path="/admin/job-applicants"
              element={<JobPostResponse />}
            />
            <Route path="/resources/blogs/:id" element={<BlogDetailPage />} />

            

              <Route path="/resources/case-studies" element={<CaseStudiesPage />}/>
            <Route
              path="/resources/case-studies/:slug"
              element={<CaseStudyDetailPage />}
            />
            {/* Legacy route */}
            <Route path="/case-studies" element={<CaseStudiesPage />} />
            <Route
              path="/case-studies/:slug"
              element={<CaseStudyDetailPage />}
            />

            {/* About Us */}
            <Route path="/about" element={<AboutCompanyPage />} />
            <Route path="/about/company" element={<AboutCompanyPage />} />
            <Route path="/about/leadership" element={<LeadershipPage />} />
            <Route path="/about/partners" element={<PartnersPage />} />
            <Route
              path="/about/life-at-infotech"
              element={<LifeAtInfotechPage />}
            />

            {/* Careers */}
            <Route path="/careers" element={<CareersPage />} />

            {/* Contact */}
            <Route path="/contact" element={<ContactPage />} />

            {/* Login */}
            <Route path="/login" element={<LoginPage />} />


            {/* Privacy Notice */}
            <Route path="/privacy-notice" element={<PrivacyNotice />} />

            {/* Terms of Service */}
            <Route path="/terms" element={<Terms />} />

            {/* Catch all - redirect to home */}
            <Route path="*" element={<HomePage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
